var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntityColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 12.0003,
    height: 12.0003,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 2.00006 5.99982)",
    fill: "#E6751A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 12.0003,
    height: 12.0003,
    transform: "matrix(0.866025 0.5 7.53505e-05 1 2.00006 5.99982)",
    fill: "#E6751A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 12.0003,
    height: 12.0003,
    transform: "matrix(-0.866025 0.5 -7.53505e-05 1 22.7859 5.99982)",
    fill: "#E6751A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 6.01311,
    height: 6.01311,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 7.18491 8.99347)",
    fill: "#E6751A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 6.01311,
    height: 6.0131,
    transform: "matrix(0.866026 0.5 7.53505e-05 1 7.18491 8.99347)",
    fill: "#E6751A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.01311,
    height: 6.0131,
    transform: "matrix(-0.866025 0.5 -7.53505e-05 1 17.6004 8.99347)",
    fill: "#E6751A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityColor);
export default __webpack_public_path__ + "static/media/entity-color.d94f6314a44ce41ea9fab18bf3b90765.svg";
export { ForwardRef as ReactComponent };